export default function Cookies() {
  return (
    <div className="em-container py-16 max-w-3xl">
      <h1 className="font-display text-4xl font-black text-primary">Gestion des cookies</h1>
      <div className="mt-8 space-y-6 text-muted-foreground leading-relaxed">
        <section>
          <h2 className="font-display text-xl font-bold text-primary mb-2">Qu'est-ce qu'un cookie ?</h2>
          <p>Un cookie est un petit fichier déposé sur votre appareil lors de la visite d'un site. Energy Market utilise des cookies de mesure d'audience et de fonctionnement.</p>
        </section>
        <section>
          <h2 className="font-display text-xl font-bold text-primary mb-2">Vos préférences</h2>
          <p>Vous pouvez à tout moment accepter ou refuser les cookies non essentiels via le bandeau de consentement et les paramètres de votre navigateur.</p>
        </section>
        <p className="text-sm">Page à compléter par l'éditeur — l'intégration d'un outil de consentement (CMP) sera réalisée à la mise en ligne.</p>
      </div>
    </div>
  );
}
